import { alpha, Paper, styled, Tab, Tabs } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Grid } from '@mui/system';
import { ITheme } from 'theme/types';

/** Dark: neutral surface. Light: original Scalar primary[600] blue bar. */
const navigationBarBackground = (theme: { palette: import('@mui/material/styles').Palette }) =>
  theme.palette.mode === 'dark' ? '#111111' : (theme as unknown as ITheme).palette.primary['600'];

export const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    navigation: {
      backgroundColor: theme.palette.primary[600],
      overflowX: 'hidden',
    },
    container: {
      margin: 0,
      padding: `0px ${theme.spacing(2)}px`,
      // width: '100%',
    },
    tabsContainer: {
      padding: '0px !important',
    },
    tabsItems: {
      // '& div[role="tablist"]': {
      //   overflowX: 'scroll'
      // },
    },
    tabItem: {
      color: '#80A4C5',
      fontSize: '12px',
      fontWeight: 600,
      minWidth: 0,
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,

      '&:hover': {
        color: theme.palette.white,
      },
    },
    selected: {
      color: theme.palette.white,
    },
    navChildren: {},
  })
);

export const NavigationPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: navigationBarBackground(theme),
  overflowX: 'hidden',
  borderRadius: 0,
  backgroundImage: 'none',
  boxShadow: 'none',
  ...(theme.palette.mode === 'dark' && {
    borderBottom: '1px solid rgba(255,255,255,0.07)',
  }),
}));

export const Container = styled(Grid)(({ theme }) => ({
  margin: 0,
  padding: `0px ${theme.spacing(2)}`,
}));

export const TabsContainer = styled(Grid)({
  padding: '0px !important',
});

export const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

export const StyledTab = styled(Tab)(({ theme }) => {
  const isDark = theme.palette.mode === 'dark';
  // Dark: soft new accent. Light: white (readable on primary[600] blue bg).
  const accentColor = isDark ? theme.palette.primary.main : theme.palette.common.white;
  return {
    color: isDark ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.80)',
    fontSize: '12px',
    fontWeight: 600,
    minWidth: 0,
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    textTransform: 'none',
    transition: 'color 120ms ease',

    '&:hover': {
      color: theme.palette.common.white,
    },

    '&.Mui-selected': {
      color: `${theme.palette.common.white} !important`,
      '&::after': {
        transform: 'scaleX(1)',
      },
    },

    '&::after': {
      content: '""',
      height: '2px',
      borderRadius: '2px 2px 0 0',
      backgroundColor: accentColor,
      width: 'calc(100% - 32px)',
      position: 'absolute',
      bottom: 0,
      left: '16px',
      transform: 'scaleX(0)',
      transformOrigin: 'left',
      transition: 'transform 200ms ease',
    },
  };
});

export const NavChildren = styled(Grid)({
  marginLeft: 'auto',
  marginRight: '12px',
  display: 'flex',
  alignItems: 'center',
});

